module.exports = __webpack_public_path__ + "static/img/6.a63c8d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/6.png
// module id = So+S
// module chunks = 0